export enum STATUS_MODAL {
  ADD = 1,
  EDIT = 2,
}

// export const WORKER_SCHEDULE_STATUS: {
//   0: any;
//   1: any;
//   2: any;
// } = {
//   0: '作業員登録なし',
//   1: '作業員登録あり',
//   2: '遅延登録あり',
// };
export enum WORKER_SCHEDULE_STATUS {
  作業員登録なし = 0,
  作業員登録あり = 1,
  遅延登録あり = 2,
}
